import { IDownloadParticipantsRenderedItem } from 'entities/downloads/participants/types';
import { ColumnConfigType } from 'shared/types';
import { IDownloadPrizesRenderedItem } from 'entities/downloads/prizes/types';

export const columnConfigDownloadPromo: ColumnConfigType<IDownloadParticipantsRenderedItem>[] = [
  {
    dataFieldName: 'activity_id',
    name: 'ID Акции',
    width: '6%',
  },
  {
    dataFieldName: 'activity_name',
    name: 'Название Акции',
    width: '30%',
  },
  {
    dataFieldName: 'file_name',
    name: 'Имя Файла',
    width: '16%',
  },
  {
    dataFieldName: 'created_at',
    name: 'Дата Загрузки',
    width: '16%',
  },
  {
    dataFieldName: 'status',
    name: 'Статус обработки',
    width: '16%',
  },
  {
    dataFieldName: 'downloaded',
    name: 'Загружено',
    width: '16%',
  },
];

export const columnConfigDownloadPrize: ColumnConfigType<IDownloadPrizesRenderedItem>[] = [
  {
    dataFieldName: 'id',
    name: 'ID Приза',
    width: '6%',
  },
  {
    dataFieldName: 'prize_name',
    name: 'Название Приза',
    width: '30%',
  },
  {
    dataFieldName: 'file_name',
    name: 'Имя Файла',
    width: '16%',
  },
  {
    dataFieldName: 'created_at',
    name: 'Дата Загрузки',
    width: '16%',
  },
  {
    dataFieldName: 'status',
    name: 'Статус обработки',
    width: '16%',
  },
  {
    dataFieldName: 'downloaded',
    name: 'Загружено',
    width: '16%',
  },
];
